import { Observable } from "rxjs/Observable";
import * as actions from "./job-status-summary.actions";
import { AccountObjectStoreFacade } from "../account-object/account-object.store-facade";
import { Account } from "../account/account.model";
import { JobStatusSummary } from "./job-status-summary.model";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import { Qry } from "../query-facade";

export class JobStatusSummaryStoreFacade extends AccountObjectStoreFacade<JobStatusSummary> {

    getAll(): Observable<Array<JobStatusSummary>> {
        return this.select(Qry.getInstance().jobStatusSummary.items);
    }

    getByAccount(account: Account): Observable<JobStatusSummary> {
        return this.getAll()
            .map(items => items.find(item => item.account === account.id));
    }

    create(item: JobStatusSummary): void {
        this.insert(item);
    }

    update(item: JobStatusSummary): void {
        this.dispatch(new actions.SubmitAction(item));
    }

    insert(item: JobStatusSummary): void {
        this.dispatch(new actions.SubmitAction(item));
    }

    remove(item: JobStatusSummary, options?: ActionOptionsArgs): void {
        this.dispatch(new actions.RemoveAction(item, options));
    }

    canDelete(item: JobStatusSummary): Observable<boolean> {
        return Observable.of(true);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-status-summary-item/job-status-summary.store-facade.ts